module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Import-483147729964b499153197005d70dc97.svg";